// @ts-strict-ignore
import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";

export const PointInputValidator: ValidatorFn = (control: AbstractControl): ValidationErrors => {
	if (!control.value) {
		return Validators.required(control);
	}

	if (Math.floor(control.value) !== control.value) {
		return {invalidNumber: true};
	}
	return null;
};
